import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    input[type='time']::-webkit-clear-button {\n        display: none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback } from 'react';
import styled from 'styled-components';
import { isAfter, isBefore, isEqual, isSameDay, lightFormat, set } from 'date-fns';
import { TextField } from '../TextField';
var TIME_FORMAT = 'HH:mm';
var DEFAULT_TIME = '00:00';
var StyledTimeInput = styled(TextField)(_templateObject());

function fixValue(value, currentDate, minDate, maxDate) {
  if (!currentDate || !(minDate && maxDate)) {
    return value;
  }

  var date = set(currentDate, {
    seconds: 0,
    milliseconds: 0
  });

  if (isEqual(date, minDate)) {
    return lightFormat(minDate, TIME_FORMAT);
  }

  if (isEqual(date, maxDate)) {
    return lightFormat(maxDate, TIME_FORMAT);
  }

  return value;
}

export function limitDate(date, minDate, maxDate) {
  var hours = date.getHours();
  var minutes = date.getMinutes();

  if (minDate && isSameDay(date, minDate) && isBefore(set(minDate, {
    hours: hours,
    minutes: minutes
  }), minDate)) {
    return minDate;
  } else if (maxDate && isSameDay(date, maxDate) && isAfter(set(maxDate, {
    hours: hours,
    minutes: minutes
  }), maxDate)) {
    return maxDate;
  }

  return date;
}
export var DatepickerTimeInput = function DatepickerTimeInput(_a) {
  var value = _a.value,
      minDate = _a.minDate,
      maxDate = _a.maxDate,
      currentDate = _a.currentDate,
      onChange = _a.onChange,
      props = __rest(_a, ["value", "minDate", "maxDate", "currentDate", "onChange"]);

  var handleChange = useCallback(function (event) {
    var _event$value = event.value,
        value = _event$value === void 0 ? DEFAULT_TIME : _event$value;

    var _value$split$map = value.split(':').map(Number),
        _value$split$map2 = _slicedToArray(_value$split$map, 2),
        hours = _value$split$map2[0],
        minutes = _value$split$map2[1];

    var date = value;

    if (currentDate) {
      var limitedDate = limitDate(set(currentDate, {
        hours: hours,
        minutes: minutes
      }), minDate, maxDate);
      date = lightFormat(limitedDate, TIME_FORMAT);
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(date);
  }, [currentDate, minDate, maxDate]);
  return React.createElement(StyledTimeInput, Object.assign({}, props, {
    value: fixValue(value, currentDate, minDate, maxDate),
    onChange: handleChange
  }));
};
DatepickerTimeInput.displayName = 'DatepickerTimeInput';